import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-header container">
        <h1>개인정보 처리방침</h1>
      </div>

      <div className="privacy-content container">
        <section className="privacy-section">
          <h2>1. 개인정보 수집 항목</h2>
          <p>MIMIC 앱은 다음과 같은 개인정보를 수집합니다.</p>
          <ul>
            <li><strong>이메일 주소</strong>: 계정 연동 시 사용 및 고유 사용자 식별</li>
            <li><strong>사용 가능 시간 정보</strong>: 서비스 이용 현황으로 사용자 계정에 연결</li>
          </ul>
          <p className="note">※ 위 정보 외에는 서버에 저장하지 않으며, 광고·추적·마케팅 목적으로 사용하지 않습니다.</p>
        </section>

        <section className="privacy-section">
          <h2>2. 수집 목적</h2>
          <p>수집된 개인정보는 다음 목적으로만 사용됩니다.</p>
          <ul>
            <li>회원 계정 생성/식별 및 인증</li>
            <li>구매 재화(사용 가능 시간)의 유효성 및 이용 상태 관리</li>
            <li>앱 기능 제공 및 보안/해킹 방지</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. 수집 방법</h2>
          <ul>
            <li>사용자 입력(로그인 시 이메일)</li>
            <li>앱 서비스 이용 중 자동 생성 데이터(사용 가능 시간 상태)</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. 개인정보 보유 및 이용 기간</h2>
          <p>
            사용자가 계정을 삭제 또는 탈퇴 요청 시, 해당 정보는 즉시 <strong>영구 삭제</strong>됩니다.
            서비스 운영을 위해 합법적인 범위 내에서만 보유하며, 별도의 장기 보관 목적은 없습니다.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. 제3자 제공</h2>
          <p>당 앱은 수집된 개인정보를 제3자(광고/마케팅/분석 서비스 포함)에게 제공하지 않습니다.</p>
        </section>

        <section className="privacy-section">
          <h2>6. 정보주체 권리</h2>
          <p>
            이용자는 언제든지 자신의 개인정보 열람·정정·삭제·처리정지 요청을 할 수 있습니다.<br/>
            요청은 앱 설정 또는 고객지원 이메일 (<a className="link" href="mailto:master@mimic.blog">master@mimic.blog</a>)으로 신청해주세요.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. 개인정보 보호책임자</h2>
          <p>
            베네핏브로스 / <a className="link" href="mailto:master@mimic.blog">master@mimic.blog</a>
          </p>
        </section>
      </div>

      <div className="privacy-footer container">
        <p>최종 수정일: 2025년 12월</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
